import type {
  RecordFormColumns,
  RecordFormField,
  RecordFormTab,
  RecordFormTabOrientation,
  RecordFormTabPanelPlacement,
} from "features/shared/components/dynamic-form/types";
import type { ReactNode } from "react";

import { DynamicRecordDrawer } from "features/shared/components/dynamic-form";

type TechnicalConfigDrawerProps = {
  columns?: RecordFormColumns;
  deleteLabel?: string;
  fields: RecordFormField[];
  headerColumns?: RecordFormColumns;
  isConfigured: boolean;
  isDeleting?: boolean;
  isLoading?: boolean;
  isSubmitting?: boolean;
  onClose: () => void;
  onDelete?: () => void;
  onSave: () => void;
  open: boolean;
  subtitle?: string;
  tabOrientation?: RecordFormTabOrientation;
  tabPanelPlacement?: Partial<Record<string, RecordFormTabPanelPlacement>>;
  tabPanels?: Partial<Record<string, ReactNode>>;
  tabs: RecordFormTab[];
  title: string;
  widthClassName?: string;
};

export const TechnicalConfigDrawer = ({
  columns = 2,
  deleteLabel,
  fields,
  headerColumns,
  isConfigured,
  isDeleting,
  isLoading,
  isSubmitting,
  onClose,
  onDelete,
  onSave,
  open,
  subtitle,
  tabOrientation = "horizontal",
  tabPanelPlacement,
  tabPanels,
  tabs,
  title,
  widthClassName = "w-[70rem]",
}: TechnicalConfigDrawerProps) => (
  <DynamicRecordDrawer
    columns={columns}
    fields={fields}
    headerColumns={headerColumns}
    isDeleting={isDeleting}
    isLoading={isLoading}
    isSubmitting={isSubmitting}
    mode={isConfigured ? "edit" : "add"}
    onClose={onClose}
    onDelete={isConfigured ? onDelete : undefined}
    onDeleteLabel={deleteLabel}
    onSave={onSave}
    open={open}
    subtitle={subtitle}
    tabOrientation={tabOrientation}
    tabPanelPlacement={tabPanelPlacement}
    tabPanels={tabPanels}
    tabs={tabs}
    title={title}
    widthClassName={widthClassName}
  />
);
